import { useState, createContext, useContext} from 'react';


export const Store = createContext({})


export default function StoreProvider({children}){
   const [data, setData] = useState({});

   return(
     <Store.Provider value={{
       data, setData
     }}
     >
       {children}
     </Store.Provider>
   )
}


export const useStore = () => {
  return useContext(Store)
}